(() => {
  const form = $('.subscription-cancel');
  if (!form.length) return;

  const questions = [
    'question_experience',
    'question_recommend',
    'question_work'
  ];

  const validateQuestions = () => {
    let valid = true;

    questions.forEach((name) => {
      const question = $(`[name=${name}]`).closest('[data-js-unsub-question]');
      if (!$(`input[name=${name}]:checked`).length) {
        valid = false;
        question.addClass('error');
      } else {
        question.removeClass('error');
      }
    });

    return valid;
  }

  const validateReasons = () => {
    let valid = true;
    const formData = form.serializeArray();
    const reasons = formData.filter(item => item.name === 'cancel_reason[]').map(item => item.value);
    const customReason = formData.find(item => item.name === 'cancel_reason[other]')?.value;

    if (customReason === '') {
      $('[name="cancel_reason[other]"]').addClass('has-error').focus();
      $('[data-js-unsub-custom-error]').addClass('active');
      valid = false;
    } else {
      $('[data-js-unsub-custom-error]').removeClass('active');
      $('[name="cancel_reason[other]"]').removeClass('has-error');
    }
    if (reasons.length === 0 && customReason === undefined) {
      valid = false;
      $('[data-js-unsub-error]').addClass('active')
    } else {
      $('[data-js-unsub-error]').removeClass('active')
    }

    return valid;
  }

  const validate = () => {
    const reasonsSection = $('.unsub-cancel__items-wrp');

    let valid = true;
    const validReasons = validateReasons();
    const validQuestions = validateQuestions();

    if (!validReasons) {
      // Scroll to bottom of reasons section
      $('html, body').animate({
        scrollTop: reasonsSection.offset().top + reasonsSection.outerHeight() - $(window).height() + 30
      }, 500);
    }
    if (!validQuestions && validReasons) {
      // Scroll to questions section if mobile
        $('html, body').animate({scrollTop: $('[data-js-unsub-question]').offset().top - 80}, 500);
    }

    if (!validReasons) valid = false;
    if (!validQuestions) valid = false;

    return valid;
  }

  // Clear errors
  questions.forEach((q) => {
    $(`input[name=${q}]`).on('change', () => {
      $(`[name=${q}]`).closest('[data-js-unsub-question]').removeClass('error');
    });
  });

  $('[name="cancel_reason[other]"]').on('input', (e) => {
    if (e.target.value !== '') {
      $('[data-js-unsub-custom-error]').removeClass('active');
      $('[name="cancel_reason[other]"]').removeClass('has-error');
    }
  });

  $('.unsub-cancel__item').on('click', () => {
    $('[data-js-unsub-error]').removeClass('active')
  });

  form.on('submit', (e) => {
    e.preventDefault();
    if(!validate()) {
      e.stopPropagation();
    }
  });
})();
